module.exports = "/_next/static/images/f11506bc3dd07ac0a2349e7cadaee0dd-Nubank_HickDuarte_57380_xs.png.webp";